import { ListBox, ListBoxItem, Select } from '@heroui/react';

export interface SelectOption {
  label: string;
  value: string;
}

// 贴 TDesign options 数组心智的下拉封装,收敛 Select 五层组合结构
export function SimpleSelect({
  value,
  onChange,
  options,
  placeholder,
  className,
  'aria-label': ariaLabel,
  isDisabled,
}: {
  value: string | null | undefined;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  className?: string;
  'aria-label'?: string;
  isDisabled?: boolean;
}) {
  return (
    <Select
      aria-label={ariaLabel ?? placeholder ?? '选择'}
      className={className}
      isDisabled={isDisabled}
      placeholder={placeholder}
      selectedKey={value ?? null}
      onSelectionChange={(key) => {
        if (key != null) onChange(String(key));
      }}
    >
      <Select.Trigger>
        <Select.Value />
        <Select.Indicator />
      </Select.Trigger>
      <Select.Popover>
        <ListBox>
          {options.map((opt) => (
            <ListBoxItem key={opt.value} id={opt.value} textValue={opt.label}>
              {opt.label}
            </ListBoxItem>
          ))}
        </ListBox>
      </Select.Popover>
    </Select>
  );
}
